import React from 'react';

const Smile = ({ color = '#fff' }) => (
  <svg width="20" height="21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 .5c5.523 0 10 4.477 10 10s-4.477 10-10 10-10-4.477-10-10S4.477.5 10 .5zm0 9c-2 0-3.667.333-5 1a5 5 0 1010 0c-1.333-.667-3-1-5-1zm-3.5-4c-1.152 0-2.122.78-2.412 1.84l-.038.16h4.9a2.5 2.5 0 00-2.45-2zm7 0c-1.152 0-2.122.78-2.412 1.84l-.038.16h4.9a2.5 2.5 0 00-2.45-2z"
      fill={color}
    />
  </svg>
);

export default Smile;
